<script lang="ts">
  import Link from "svelte-link/src/Link.svelte";
  import { href, Month, Today,TopSellingProduct } from "../../../../utils/Constant/Constant";
  import Card from "../../../Core/Card.svelte";
  import RatingStar from "../../../Core/RatingStar.svelte";
  import { Col, Image } from "sveltestrap";
  let imgPath: string = "/assets/images/dashboard-2";
</script>

<Col xl="6" class="box-col-6 top-sell-sec">
  <Card cardHeaderprops="pb-0">
    <div class="header-top d-sm-flex justify-content-between align-items-center" slot="customheader" >
      <h5>{TopSellingProduct}</h5>
      <div class="center-content">
        <ul class="week-date">
          <li class="font-primary">{Today}</li>
          <li>{Month}</li>
        </ul>
      </div>
    </div>
    <div slot="contentbody">
      <div class="media">
        <Image fluid src="{imgPath}/9.png" alt="" />
        <div class="media-body">
          <Link {href}>
            <h6>Trending Nike shoes</h6>
          </Link>
          <p>New Offer Only $126.00</p>
          <RatingStar />
        </div>
        <Link class="btn btn-iconsolid" {href}>
          <i class="icon-bag" />
        </Link>
      </div>
    </div>
  </Card>
</Col>